import { Component, OnInit } from '@angular/core';
import { DxauthService } from 'src/app/dxauth.service';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sas-clinic-register',
  templateUrl: './sas-clinic-register.component.html',
  styleUrls: ['../style/global.css', './sas-clinic-register.component.css'],
})
export class SasClinicRegisterComponent
  extends BaseLoginComponent
  implements OnInit {
  public acceptTerm = false;
  public acceptPrivacyPolicy = false;
  isRegistable = true;
  public initialized: boolean = true;

  async init(): Promise<void> { }

  registrationRole(): string {
    return undefined;
  }

  get baseLink() {
    return environment.apps[this.clientId].appUrl;
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }

  get privacyUrl() {
    return environment.apps[this.clientId].privacyUrl;
  }

  get termsUrl() {
    return environment.apps[this.clientId].termUrl;
  }

  get appname() {
    return 'SASオンラインクリニック';
  }

  submittable(): boolean {
    // 親クラスのバリデーション処理をまず実施
    if (!super.submittable()) return false;
    // SAS向けのバリデーション処理
    const isValidPassword = DxauthService.passwordValidator(this.password, {
      minLength: 10,
      isCharaUnique: false,
    });
    if (isValidPassword.isValid === false) {
      this.errorMessages.signup.password = isValidPassword.errorMessage;
      return false;
    }
    return true;
  }
}
